import type { ActivityModule } from '../../core/activity';
import { mountLearnDigits } from './ui';
import levelsData from './levels.json';
import './style.css';

export const learnDigits: ActivityModule = {
  id: 'learn_digits',
  title: 'Aprendendo os números',
  description: 'Associe dígitos (0–9) às quantidades representadas por mãos ou pontos. Progressão da idade pré-escolar.',
  ageMin: 4,
  ageMax: 7,
  difficulty: 1,
  iconPath: 'assets/gcompris-AGPL/learn_digits/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountLearnDigits,
};
